module.exports = __webpack_public_path__ + "img/level1.07801472.png";